import React from 'react';


const AkhuwatLoanInstruction = ()=>{
  return (
    <section className="container-fluid py-5">
      <div className="container">
        <h1 className="text-center mb-4 fw-bold">Check the Status of Your Application</h1>
        
        <p className="text-center mb-5">
        You may easily check your application history and details at any moment with Travel Agency 4u.
        </p>
        
        <h2 className="fw-bold mb-4">How to Verify Your Status</h2>
        
        <ol className="fs-5">
          <li className="mb-2">Visit the Travel Agency 4u website.</li>
          <li className="mb-2">Launch the "Application Status Checker" application.</li>
          <li className="mb-2">Select "Check Status."</li>
          <li className="mb-2">View the specifics of your application, such as:</li>
          <ul>
            <li>Application status as of right now</li>
            <li>Documents submitted</li>
            <li className="mb-2">The next necessary actions</li>
          </ul>
          <li className="mb-2">Our support staff can be reached via message at any time if you need assistance.</li>
        </ol>
      </div>
    </section>
  );
}

export default AkhuwatLoanInstruction
